import React, { useEffect, useRef, useState } from "react";
import TableContainer from "../../../components/layout/table-container/table-container";
import UpArrow from "../../../assets/icons/filterArrowUp.svg";
import DownArrow from "../../../assets/icons/filterArrowDown.svg";
import { useDispatch } from "react-redux";
import { onboardingDistributorList } from "../../../redux/actions/distributorActions";
import ErrorPopup from "../../../components/popups/ErrorPopup";
import OnboardingDistributorListTableData from "./onboarding-distributor-list-table-data";
import LoadingSpinnerTable from "../../../components/utilites/loaderSpinningContainer";
import { useNavigate } from "react-router-dom";
import NumberPagination from "../../../components/Pagination/number-pagination";

const OnboardingDistributorListTable = ({ search, status, page_no }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const componentRef = useRef();
  const [page, setPage] = useState(page_no ? page_no : 1);
  const [openStatus, setOpenStatus] = useState(false);
  const [distributorListData, setDistributorData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [catchedErrorPopup, setCatchedErrorPopup] = useState(false);
  const [catchedErrorMsg, setCatchedErrorMsg] = useState();

  useEffect(() => {
    if (page_no) {
      setPage(page_no);
    }
  }, [page_no]);

  useEffect(() => {
    dispatch(
      onboardingDistributorList(
        {
          search,
          page,
          status:
            status === "active" ? true : status === "inactive" ? false : null,
        },
        onSuccess,
        onError
      )
    );
    setLoading(true);
  }, [page, status, search, dispatch]);

  const onSuccess = (data) => {
    console.log(data);
    setLoading(false);
    setDistributorData(data.data.data);
  };

  const closeCatchedErrPopup = () => {
    setCatchedErrorPopup(false);
  };

  const onError = (err) => {
    setLoading(false);
    console.log(err);
    setCatchedErrorPopup(true);
    setCatchedErrorMsg(err.data.message);
  };

  const distributorListFunc = () => {
    dispatch(onboardingDistributorList({ search, page }, onSuccess, onError));
  };

  const handleClickOutside = (event) => {
    if (componentRef.current && !componentRef.current.contains(event.target)) {
      setOpenStatus(false);
    }
  };

  useEffect(() => {
    if (openStatus) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [openStatus]);

  const queryParams = [];
  if (search) queryParams.push(`search=${search}`);
  if (status) queryParams.push(`status=${status}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  return (
    <>
      <TableContainer>
        <table>
          <thead>
            <tr className="table-rows color_747f9e">
              <th className="table-heads " width={"4%"}>
                #
              </th>
              <th className="table-heads " width={"10%"}>
                Distributor ID
              </th>
              <th className="table-heads " width={"8%"}>
                Distributor Name
              </th>

              <th className="table-heads" width={"10%"}>
                Manufacturer Name
              </th>
              <th className="table-heads " width={"10%"}>
                Email Status
              </th>
              <th
                ref={componentRef}
                className="table-heads text-nowrap"
                width={"8%"}
              >
                <span
                  className={
                    openStatus
                      ? "Medium_Purple cursor_pointer"
                      : "cursor_pointer"
                  }
                  onClick={() => setOpenStatus(!openStatus)}
                >
                  <span className={status ? "Medium_Purple fw_700" : ""}>
                    Status
                  </span>
                  {openStatus ? (
                    <img src={UpArrow} className="mb-1 mx-1" alt="v" />
                  ) : (
                    <img src={DownArrow} className="mx-1" alt="v" />
                  )}
                </span>
                {openStatus ? (
                  <div className=" position-relative">
                    <div className="position-absolute status-container d-flex gap-3 px-3">
                      <div className="d-flex align-items-center ">
                        <input
                          className="radio me-2"
                          type="radio"
                          id="active"
                          name="status"
                          value={"active"}
                          checked={status === "active"}
                          onClick={(e) => {
                            setOpenStatus(!openStatus);
                            navigate(
                              `/distributors/onboard-distributor?page=1${
                                search ? `&search=${search}` : ""
                              }&status=active`
                            );
                          }}
                        />
                        <label
                          htmlFor="active"
                          className={
                            status === "active"
                              ? "color_262c3d cursor_pointer"
                              : "color_747f9e cursor_pointer"
                          }
                        >
                          Active
                        </label>
                      </div>
                      <div className="d-flex align-items-center ">
                        <input
                          className="radio me-2"
                          type="radio"
                          id="inactive"
                          name="status"
                          value={"inactive"}
                          checked={status === "inactive"}
                          onClick={(e) => {
                            setOpenStatus(!openStatus);
                            navigate(
                              `/distributors/onboard-distributor?page=1${
                                search ? `&search=${search}` : ""
                              }&status=inactive`
                            );
                          }}
                        />
                        <label
                          htmlFor="inactive"
                          className={
                            status === "inactive"
                              ? "color_262c3d cursor_pointer"
                              : "color_747f9e cursor_pointer"
                          }
                        >
                          Inactive
                        </label>
                      </div>
                      <button
                        className="filter-btn px-2 py-0 my-2 fs_12"
                        style={{ height: "28px" }}
                        onClick={() => {
                          setOpenStatus(!openStatus);
                          navigate(
                            `/distributors/onboard-distributor?page=1${
                              search ? `&search=${search}` : ""
                            }`
                          );
                        }}
                      >
                        CLEAR
                      </button>
                    </div>
                  </div>
                ) : null}
              </th>
              <th className="table-heads " width={"22%"}>
                Actions
              </th>
            </tr>
          </thead>
          <tbody style={{ position: "relative" }}>
            {loading === true ? (
              <div className="list-spinner-container">
                <LoadingSpinnerTable show={loading} />
              </div>
            ) : distributorListData?.distributors?.length > 0 ? (
              <>
                {distributorListData?.distributors?.map((eachRow, index) => (
                  <OnboardingDistributorListTableData
                    key={eachRow.id}
                    data={eachRow}
                    index={index}
                    distributorListFunc={distributorListFunc}
                    currentPage={distributorListData?.pagination?.currentPage}
                  />
                ))}
              </>
            ) : (
              <tr>
                <td colSpan="1" className="text-center no-data-container fs_16">
                  <span>~ No Data Found ~</span>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </TableContainer>
      <div className={loading === true ? `loading-event` : ""}>
        {distributorListData?.pagination?.totalPages > 0 && (
          <NumberPagination
            setCurrentPage={setPage}
            pagination={distributorListData?.pagination?.currentPage}
            totalPages={distributorListData?.pagination?.totalPages}
            path={"/distributors/onboard-distributor"}
            filters={`${queryString}`}
          />
        )}
      </div>
      <ErrorPopup
        show={catchedErrorPopup}
        title={catchedErrorMsg}
        handleClose={closeCatchedErrPopup}
      />
    </>
  );
};

export default OnboardingDistributorListTable;
